import classNames from 'clsx';
import React from 'react';
import type { MdComponentIndexProps } from '../type';
import styles from './Tip.module.less';

function transformBoolean(val: any) {
  if (typeof val === 'boolean') {
    return val;
  }
  if (val === 'true') {
    return true;
  }
  if (val === 'false') {
    return false;
  }
  return undefined;
}

export function MarkdownTipInfo(
  props: React.PropsWithChildren<
    {
      border?: boolean;
    } & MdComponentIndexProps
  >,
) {
  const border = transformBoolean(props.border) ?? true;
  return (
    <div
      className={classNames(styles.TipContainer, styles.TipContainerShowLine)}
      data-first={props['data-first']}
      data-last={props['data-last']}
    >
      <div className="flex items-center pl-1">
        <div className="relative mr-4 w-4 h-4 rounded-full text-white flex items-center justify-center">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{
              scale: 'calc(24 / 20)',
              marginBottom: 2,
            }}
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M10 22C15.5228 22 20 17.5228 20 12C20 6.47715 15.5228 2 10 2C4.47715 2 0 6.47715 0 12C0 17.5228 4.47715 22 10 22ZM12.0686 7.34746C12.0686 6.77746 11.7031 6.28001 10.9722 6.28001C10.0111 6.28001 9.53056 7.06328 9.53056 7.63219C9.51147 8.30855 9.9151 8.71764 10.6073 8.71764C11.4336 8.71764 12.0686 8.05928 12.0686 7.34746ZM8.12711 15.2669C7.72347 16.8335 8.1462 17.1891 8.72329 17.1891C9.29929 17.1891 10.79 16.6546 12.1547 15.2653L11.8275 14.8213C11.27 15.2658 10.7027 15.4796 10.5298 15.4796C10.3951 15.4796 10.3378 15.3018 10.472 14.7864L11.2307 11.8671C11.5187 10.7996 11.4227 10.1053 10.8462 10.1053C10.1535 10.1053 8.53947 10.804 7.13657 11.9964L7.42457 12.4764C7.86802 12.1736 8.61638 11.8671 8.78929 11.8671C8.92347 11.8671 8.90438 12.0455 8.78929 12.4895L8.12711 15.2669Z"
              fill="var(--ui-fill-7)"
            />
          </svg>
          {border ? (
            <div
              className={classNames('absolute top-full mt-1 rounded-full', styles.TipLine)}
              style={{
                width: 1,
                backgroundColor: `var(--ui-fill-5)`,
                left: `0.46875rem`,
                height: `calc(var(--markdown-x-component-gap) + 0px)`, // 16px
                top: `calc(var(--markdown-x-component-gap) + 1px)`, // 16px + 1px
              }}
            />
          ) : null}
        </div>
        <div className="m-0 flex-1 text-base font-semibold text-slate-900 dark:text-slate-200 markdown-child-root">
          {props.children}
        </div>
      </div>
    </div>
  );
}

MarkdownTipInfo.attributes = ['border'] as string[];
